import React from "react";
import Form from "./Form";
import Cart from "./Cart";
import { Outlet, Link } from "react-router-dom";
import { MyCustomContextHook } from "./Context";

const Navbar = ({ removeExtraSubmenu }) => {
  const { showSubmenu, sideBarOpen, submenuClosed } = MyCustomContextHook();

  const displaySubMenu = (e) => {
    const page = e.target.textContent;
    const tempBtn = e.target.getBoundingClientRect();
    const center = tempBtn.left;
    const bottom = tempBtn.bottom + 5;
    showSubmenu(page, { center, bottom });
  };

  const removeWhileNotonNav = (e) => {
    if (!e.target.classList.contains("list-items")) submenuClosed();
  };
  return (
    <>
      <nav className="nav" onMouseOver={removeExtraSubmenu}>
        <div
          className="nav-center nav-center-plus"
          onMouseOver={removeWhileNotonNav}
        >
          <div className="nav-header">
            <span className="btn toggle-btn" onClick={sideBarOpen}>
              <i className="ri-menu-line"></i>
            </span>
          
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Udemy_logo.svg/2560px-Udemy_logo.svg.png"
                className="nav-logo"
                alt=""
              />
          

            <div className="icons">
              <span className="search">
                <i className="ri-search-line"></i>
              </span>
              <span className="sm-cart">
                <Cart />
              </span>
            </div>
          </div>
          <ul className="nav-links">
            <li>
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Udemy_logo.svg/2560px-Udemy_logo.svg.png"
                className="nav-logo-bg"
                alt=""
              />
            </li>
            <li className="list-items" onMouseOver={displaySubMenu}>
              Categories
            </li>
            <li>
              <Form />
            </li>
            <li className="list-items" onMouseEnter={displaySubMenu}>
              Udemy Bunisness
            </li>
            <li className="list-items" onMouseEnter={displaySubMenu}>
              Teach on Udemy
            </li>

            <li>
              <div className="sign-btn">
                <Cart />

                <button className="gen-btn login-btn">Login In</button>
                <button className="gen-btn sign-up-btn">Sign Up</button>
                <button className="earth-btn">
                  <i class="ri-global-line"></i>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    
    </>
  );
};

export default Navbar;
